import React from "react";

const AboutDetails = () => {
  return (
    <div className="about-details-wrapper">
      <div className="about-us">
        <h1 className="about-title">About RRL</h1>
        <p className="about-description">
          Since 2013 we are participating in ABU Robocon, our only goal is to
          represent our country in International Robocon and win the
          International Title. We have always found many intriguing and
          interesting technologies, motivating us to investigate and research as
          many sources of information as we could get our hands on. Looking
          back, it’s that passion and commitment to exploration and discovery
          that has contributed to our research and success. Get in touch if
          you’d like to learn more about us and what we are working on now.
        </p>
      </div>
      <div className="about-college">
        <h1 className="about-title">Our College</h1>
        <h2 className="about-subtitle">
          GOVERNMENT COLLEGE OF ENGINEERING AND RESEARCH, AWASARI KHURD
        </h2>
        <p className="about-description">
          The college is located in pollution free environment and conducive
          ambience, about 65 km North of Pune, on Pune-Nashik highway (NH-50)
          and 65 km from holy shrine Bhimashankar, in the land of Maratha
          warrior Chhatrapati Shivaji Maharaj. College campus is spread over 50
          acre area with huge academic buildings along with a separate
          administrative and workshop buildings, a separate residential zone
          with quarters for faculty and staff and hostels. The college is
          approved by All India Council for Technical Education, New Delhi and
          is affiliated to Savitribai Phule Pune University. Directorate of
          Technical Education, Maharashtra State, Mumbai controls institute
          through its Regional office at Pune.
        </p>
      </div>
    </div>
  );
};

export default AboutDetails;
